import { useEffect, useState } from "react";
import classes from "./StudioCard.module.css"
// import { useDeleteStudio } from '../../hooks/useDeleteStudio';
import rocketImage from "../../public/studioErstellen/rocketImage.webp";
import { useTextTruncate } from '../../hooks/useTextTruncate';

export const StudioCard = ({ studio, onClick, fromServicesStudios }) => {
  // const { deleteStudio, loading: deleteLoading } = useDeleteStudio();
  const { textRef, containerRef, truncatedText } = useTextTruncate(studio.name);
  const [studioImageLoaded, setStudioImageLoaded] = useState(() => !studio?.image);

  useEffect(() => {
    setStudioImageLoaded(!studio?.image);
  }, [studio?.image]);

  // const handleDelete = async (e) => {
  //   e.stopPropagation(); // Prevent triggering the card click
    
  //   if (!studio || !studio.id) {
  //     alert('Cannot delete studio: Invalid studio data');
  //     return;
  //   }
  
  //   if (window.confirm('Are you sure you want to delete this studio?')) {
  //     try {
  //       const result = await deleteStudio(studio.id);
  //       if (result.success) {
  //         alert('Studio deleted successfully');
  //         // Optionally refresh the page or trigger a refetch
  //       } else {
  //         alert('Failed to delete studio: ' + result.error);
  //       }
  //     } catch (error) {
  //       console.error('Error deleting studio:', error);
  //       alert('An error occurred while deleting the studio');
  //     }
  //   }
  // };

  const handleStudioCardClick = () => {
    if (fromServicesStudios) {
      onClick();
    }
  };

  const isActive = fromServicesStudios
    ? studio?.status === "ACTIVE" || !studio?.status
    : true;

  return (
    <div style={{cursor: fromServicesStudios ? "pointer" : "default"}} className={classes.studioCard} onClick={handleStudioCardClick}>
        <div className={classes.studioImage}>
          <div className={classes.originalContainer}>
            <div className={classes.originalIcon}>
              <img src={rocketImage} alt="rocket" />
            </div>
            <span>stu original</span>
          </div>
          <div className={classes.activeStatusContainer}>
            {isActive ? (
              <div className={classes.statusIndicator}></div>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <circle cx="5" cy="5" r="5" fill="#CE425D"/>
              </svg>
            )}
            <span className="regularXxs">{isActive ? "aktiv" : "inaktiv"}</span>
          </div>
          <div className={classes.studioPhotoWrap}>
            {!studioImageLoaded && (
              <div className={classes.imageSkeleton} aria-hidden />
            )}
            <img
              src={studio.image || undefined}
              alt={studio.name}
              onLoad={() => setStudioImageLoaded(true)}
              onError={() => setStudioImageLoaded(true)}
              className={studioImageLoaded ? classes.studioPhotoLoaded : classes.studioPhotoLoading}
            />
          </div>
        </div>
        <div className={classes.studioInfo}>
          <div className={classes.studioName} ref={containerRef}>
              <h3 ref={textRef} className="regularMiddle">{truncatedText}</h3>
              {/* <span className={`${classes.studioType} lightSmall`}>{studio.type}</span> */}
          </div>
          <div className={classes.studioLocation}>
              <p style={{color: "#8A8A91"}} className="regularXxs">{studio.location}</p>
          </div>
        </div>
      {/* <button 
      className={classes.deleteButton}
      onClick={handleDelete}
      disabled={deleteLoading}
      >
        {deleteLoading ? 'Deleting...' : 'Delete Studio'}
      </button> */}
    </div>
  );
};

export default StudioCard;
